module.exports = __webpack_public_path__ + "img/error.0f6a1272.png";